/*
 * preorder-notice.js — variant-aware Pre-Order Notice visibility.
 *
 * blocks/preorder-notice.liquid pre-renders one `.preorder-notice__item`
 * per variant, each carrying `data-variant-id="{variant.id}"` and a
 * `data-preorder-show` flag indicating whether that variant qualifies
 * for the notice (in stock → no, no preorder flag → no, otherwise
 * yes). On page load only the currently-selected variant's qualifying
 * item is visible.
 *
 * H3.0's variant:update event drives the swap. Scoped by
 * .shopify-section so multiple PDPs on the same page don't bleed.
 *
 * Same per-variant pattern product-page-badges.js uses; no fetch,
 * instant swap.
 */
(function () {
  function setNoticeVisibility(scope, variantId) {
    if (!scope || !variantId) return;
    var id = String(variantId);
    var wrappers = scope.querySelectorAll('.preorder-notice');

    for (var w = 0; w < wrappers.length; w++) {
      var wrapper = wrappers[w];
      var items = wrapper.querySelectorAll('[data-variant-id]');
      var anyVisible = false;

      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var matches = item.getAttribute('data-variant-id') === id;
        var show = item.getAttribute('data-preorder-show') === 'true';
        var visible = matches && show;
        item.style.display = visible ? '' : 'none';
        if (visible) anyVisible = true;
      }

      // Collapse the whole block when no item qualifies for the
      // current variant — keeps the column tight rather than
      // leaving an empty padded slot.
      wrapper.style.display = anyVisible ? '' : 'none';
    }
  }

  document.addEventListener('variant:update', function (event) {
    var detail = event && event.detail;
    var resource = detail && detail.resource;
    var variantId = resource && resource.id;
    if (!variantId) return;

    var sourceSection =
      event.target && event.target.closest
        ? event.target.closest('.shopify-section')
        : null;
    var scope = sourceSection || document;
    setNoticeVisibility(scope, variantId);
  });
})();
